module.exports = __webpack_public_path__ + "static/img/strona_020.cf1a042d.jpg";